import {Injectable, Optional} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Configuration} from "../configuration";
import {ApiRemarktypeGetRequestParams} from "./remark-type.service";

@Injectable({
    providedIn: 'root'
})
export class FacilityGetlistService {

    constructor(protected httpClient: HttpClient, @Optional() private configuration: Configuration,) {
        console.log(httpClient);
    }

    post(params: ApiRemarktypeGetRequestParams): Observable<any> {
        const localVarPath = `/api/facility/getlist`;
        return this.httpClient.request<any>(
            'post',
            `${this.configuration.basePath}${localVarPath}`,
            {
                withCredentials: this.configuration.withCredentials,
                body: params,
            }
        );
    }
}
